/* Copyright (c) 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type SidebarItemWrapperProps = {
  hasIcon?: boolean;
  hideBottomBorder?: boolean;
};

export const SidebarItemWrapper = styled.button<SidebarItemWrapperProps>`
  padding: ${calculatePadding};
  column-gap: ${theme.spacing.spacing03};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1;
  width: 100%;
  background: none;
  border: none;
  border-bottom: ${({ hideBottomBorder }) =>
    hideBottomBorder ? "none" : `1px solid ${theme.color.border.border01}`};
  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui04};
  }

  &:disabled {
    opacity: 0.5;
    color: ${theme.color.text.text03};
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const SidebarItemWrapperGrid = styled.button<SidebarItemWrapperProps>`
  padding: ${calculatePadding};
  color: ${theme.color.text.text01};
  column-gap: ${theme.spacing.spacing03};
  display: grid;
  grid-template-columns: repeat(4, max-content);
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  border-bottom: ${({ hideBottomBorder }) =>
    hideBottomBorder ? "none" : `1px solid ${theme.color.border.border01}`};
  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui04};
  }

  &:disabled {
    opacity: 0.5;
    color: ${theme.color.text.text03};
    cursor: not-allowed;
    pointer-events: none;
  }
`;

function calculatePadding({ hideBottomBorder }: SidebarItemWrapperProps) {
  return `${
    hideBottomBorder ? theme.spacing.spacing02 : theme.spacing.spacing04
  } ${theme.spacing.spacing02}`;
}
